export default {
  methods: {
    mix_filterElementsWeHaveToShow (objectsArray) {
      return (objectsArray || []).filter(element => {
        if (!element.testExperiment) {
          return true;
        }
        let showsInSpecificExperimentVersion = this.experiments && this.experiments[element.testExperiment.name] == (element.testExperiment.version || 'B');
        let showsInAllControlGroupsExperiments = this.experiments && this.experiments[element.testExperiment.name] !== undefined && this.experiments[element.testExperiment.name] !== 'A';

        return this.experiments && (showsInSpecificExperimentVersion || showsInAllControlGroupsExperiments);
      });
    },

    mix_copyOnlyElementsToShow (originalObject) {
      if (!Array.isArray(originalObject)) {
        if (originalObject && typeof originalObject === 'object' && originalObject.constructor === Object) {
          let copy = {};

          Object.keys(originalObject).forEach(key => copy[key] = this.mix_copyOnlyElementsToShow(originalObject[key]));

          return copy;
        } else {
          return originalObject;
        }
      }

      return this.mix_filterElementsWeHaveToShow(originalObject).map(element => this.mix_copyOnlyElementsToShow(element));
    },
  },
};
